import { signal } from "@preact/signals-react";
import { useQuery } from "@tanstack/react-query";

import SearchBar from "componentsv2/widgets/SearchBar";
import { layout as layoutFolio } from "../models/folio";
import { useGlobal } from "storev2/globalStore";
import { cn } from "tools/ui";
import GridCards from "componentsv2/card/GridCards";
import CardFolio from "./CardFolio";

const location = signal(null);
const wordsSearch = signal(null);

const styleLocation =
  "w-28 ml-2 text-neutral-700 text-xs border border-neutral-400 p-2 rounded-lg active:scale-95 cursor-pointer shadow-md";

const layout = layoutFolio();

function PresentsFolios({ getFolios, queryKey }) {
  const { customStore } = useGlobal();

  const {
    data: records,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [queryKey],
    queryFn: async () => getFolios(location, wordsSearch),
  });

  function handleFilter(value) {
    if (value === location.value) {
      location.value = null;
    } else {
      location.value = value;
    }
    refetch();
  }

  function handleSearch(value) {
    wordsSearch.value = value;
    if (wordsSearch.value && wordsSearch.value.length < 2) {
      return;
    }
    refetch();
  }

  return (
    <div className="w-full  bg-neutral-100 p-4">
      <div className="flex mb-2 mt-2">
        <span className="font-medium text-neutral-500 my-auto text-xl mx-4">
          LOCACIONES
        </span>
        {customStore.locations.map((item) => (
          <div
            className={cn(
              styleLocation,
              location.value === item.id ? "bg-lime-200" : "bg-stone-200",
            )}
            key={item.id}
            onClick={() => handleFilter(item.id)}
          >
            {item.name}
          </div>
        ))}
        <div className="ml-3"></div>
        <SearchBar
          name="search-widget"
          handleSearch={handleSearch}
          size="w-1/3 h-12"
        />
      </div>
      <div className="mt-4 border-2 border-dashed border-neutral-300 rounded-md p-4">
        <div className="flex">
          <span className="text-4xl font-bold text-neutral-400 mr-3">
            Presentes
          </span>
          <div className="flex text-lg h-8 w-8 text-white rounded-full font-bold bg-neutral-300">
            <span className="m-auto">{records ? records.length : 0}</span>
          </div>
        </div>
        {!isLoading && records.length > 0 && (
          <GridCards
            layout={layout}
            model={layout.model}
            records={records}
            Card={CardFolio}
          />
        )}
      </div>
    </div>
  );
}

export default PresentsFolios;
